import { AppStore, actions } from '@/store';
import type { ESocialProvider, EUserPermission, IUserProfile } from '@/store/types';
import fetcher from '@/utils/fetcher';

interface UserInfoAPI {
  uuid: string;
  name: string;
  email: string;
  avatarUrl: string;
  permission: EUserPermission;
  profileBackgroundUrl: string;
  socialProvider: ESocialProvider[];
  createdAt: number;
  agreeAt: number;
  lastActionAt: number;
  contentsCnt: number;
  classRoomsCnt: number;
  point: number;
  followerCnt: number;
  phone: string;
  actualName: string;
  belong: string;
  longIntroduction: string;
  shortIntroduction: string;
  isRequiredToChangePassword: boolean;
}

interface PointAPI {
  point: number;
  mileage: number;
}

async function getUserInfo() {
  try {
    const res = await fetcher.get('/api/profile');
    const resData = res.data.data as UserInfoAPI;

    if (resData.isRequiredToChangePassword) {
      AppStore.dispatch(actions.common.userInfo.setIsRequiredPasswordChange(true));
    }

    const point = await fetcher.get('/api/point');
    const pointData = point.data.data as PointAPI;
    return {
      uuid: resData.uuid,
      name: resData.name || resData.email.split('@')[0],
      email: resData.email,
      avatarUrl: resData.avatarUrl,
      permission: resData.permission,
      profileBackgroundUrl: resData.profileBackgroundUrl,
      socialProvider: resData.socialProvider,
      agreeAt: new Date(resData.agreeAt),
      createdAt: new Date(resData.createdAt),
      lastActionAt: new Date(resData.lastActionAt),
      money: pointData,
      contentsCnt: resData.contentsCnt,
      classRoomsCnt: resData.classRoomsCnt,
      followerCnt: resData.followerCnt,
      phone: resData.phone,
      actualName: resData.actualName,
      belong: resData.belong,
      longIntroduction: resData.longIntroduction,
      shortIntroduction: resData.shortIntroduction,
    } as IUserProfile;
  } catch (e) {
    return null;
  }
}

export default getUserInfo;
